import type { CountryCode } from '@/graphql/saleor/api';

import { COUNTRY_CALLING_CODES } from './const';

export const getPhonePrefixSelectOpts = () => {
  return COUNTRY_CALLING_CODES.slice()
    .sort((a, b) => a.label.localeCompare(b.label))
    .map((phonePrefix) => ({
      ...phonePrefix,
      label: `${phonePrefix.label} (${phonePrefix.value})`,
    }));
};
export const getPhonePrefixCode = (phonePrefixValue: string) => {
  return COUNTRY_CALLING_CODES.find(
    (phonePrefix) => phonePrefixValue === phonePrefix.value,
  )?.code;
};
export const getPhonePrefixSelectOptByCode = (code: CountryCode) => {
  const opts = getPhonePrefixSelectOpts();
  return (
    opts.find((item) => code && item.code === code.toUpperCase()) ?? opts[0]
  );
};
export const getPhonePrefixSelectOptByValue = (value: string) => {
  const opts = getPhonePrefixSelectOpts();
  return (
    opts.find((item) => value && item.value === handlePhonePrefix(value)) ??
    opts[0]
  );
};

export const handlePhonePrefix = (phonePrefix: string | undefined) => {
  if (!phonePrefix) return '';
  const prefix = phonePrefix.trim();
  if (!prefix.startsWith('+')) {
    return '+' + prefix;
  }
  const idx = prefix.lastIndexOf('+');
  if (idx !== 0) {
    return prefix.slice(idx);
  } else {
    return prefix;
  }
};
